<main>
    <section class="flex justify-between items-center mb-3">
        <h1 class="text-2xl font-bold text-gray-800">Compras</h1>

        <div class="relative group">

            <add-button label="Nueva"></add-button>

            <div class="absolute right-0 mt-0 w-56 pt-2 z-50 hidden group-hover:block group-focus-within:block">
                <div class="bg-white border border-gray-200 rounded-lg shadow-xl py-1">
                    <a routerLink="/purchase/new/invoice" class="block px-4 py-2 text-gray-700 hover:bg-gray-100">
                        Nueva Factura de compra
                    </a>
                    <a routerLink="/purchase/new/delivery-note" class="block px-4 py-2 text-gray-700 hover:bg-gray-100">
                        Nuevo Albarán de compra
                    </a>
                    <a routerLink="/purchase/new/refund" class="block px-4 py-2 text-gray-700 hover:bg-gray-100">
                        Nueva Devolución de compra
                    </a>
                </div>
            </div>
        </div>
    </section>

    <!-- <section>
        <form (submit)="onSubmit()"
            class="flex justify-between items-center my-1 bg-white rounded-lg border border-gray-200 p-2"
            [formGroup]="saveForm">
            <select name="types" id="types" formControlName="typeFilter">
                <option value="all">Todos</option>
                <option value="factura">Facturas</option>
                <option value="albaran">Albaranes</option>
                <option value="devolucion">Devoluciones</option>
            </select>
            <div>
                <label for="date_start">Fecha desde: </label>
                <input type="date" id="date_start" name="date_start" formControlName="dateStart">
            </div>
            <div>
                <label for="date_end">Fecha hasta: </label>
                <input type="date" id="date_end" name="date_end" formControlName="dateEnd">
            </div>
            <div>
                <select formControlName="provider_id"
                    class="w-full px-2 py-1 bg-neutral-50 border border-black rounded-xl text-sm font-bold focus:ring-2 focus:ring-black/5 transition-all">
                    <option [value]="null" selected>Seleccionar proveedor...</option>
                    @for(provider of dropdowns.providers; track provider.id){
                    <option [value]="provider.id">{{ provider.name }}</option>
                    }
                </select>
            </div>
            <div>
                <select formControlName="products"
                    class="w-full px-2 py-1 bg-neutral-50 border border-black rounded-xl text-sm font-bold focus:ring-2 focus:ring-black/5 transition-all">
                    <option [value]="null" selected>Seleccionar artículo...</option>
                    @for(product of dropdowns.products; track product.id){
                    <option [value]="product.id">{{ product.name }}</option>
                    }
                </select>
            </div>
            <button type="submit" class="bg-blue-500 text-white px-4 py-2 rounded">Filtrar</button>
        </form>
    </section> -->

    <sau-table #sauTable [url]="url" [filterConfig]="filterConfig" contentList="list" contentTotal="count"
        pageParamName="page" limitParamName="limit" contentTotal="total" [orientation]="orientation"
        [showOptions]="showOptions" [sizeInitialPage]="1" [headers]="headers" [canEdit]="showEditAndDeleteButtons"
        (deleteEvent)="openDeleteForm($event)" [canDelete]="showEditAndDeleteButtons"
        (editEvent)="toggleEditForm($event)"
        [customTemplates]="{ 'type': typeTmpl, 'total': totalTmpl, 'relations': relationTmpl}">

        <ng-template #typeTmpl let-item="item">
            <div class="flex flex-col items-start gap-0.5 leading-tight">
                <span class="text-xs text-gray-400 uppercase tracking-wide">{{ item.type }}</span>
                <span class="font-bold text-sm text-gray-900">{{ item.id_by_company }}</span>
                @if (item.status === 'draft') {
                <span class="inline-flex items-center gap-1 rounded-full bg-amber-100 px-2 py-0.5 text-[11px] font-medium text-amber-800"
                    title="Borrador: no ha modificado el stock">
                    <span class="h-1.5 w-1.5 rounded-full bg-amber-500"></span>
                    Borrador
                </span>
                }
            </div>
        </ng-template>

        <ng-template #totalTmpl let-item="item">
            <div class="flex flex-col items-start gap-0.5 leading-tight">
                <span class="font-bold text-sm text-gray-900" [centToEurDisplay]="item.total"></span>
                <span class="text-xs text-gray-400"><span [centToEurDisplay]="item.subtotal"></span> sin IVA</span>
            </div>
        </ng-template>

        <ng-template #relationTmpl let-item="item" let-header="header">
            <document-relation-chips [relations]="item[header.key]" [linkFor]="relationLink"
                [openInNewTab]="false"></document-relation-chips>
        </ng-template>

    </sau-table>

</main>